import { createVuetify } from 'vuetify';
import 'vuetify/styles';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { VDateInput } from 'vuetify/labs/VDateInput'
import { VCalendar } from 'vuetify/labs/VCalendar';
import { VTreeview } from 'vuetify/labs/VTreeview';


export default new createVuetify({
  components: {
    VDateInput,
    VCalendar,
    VTreeview,
    ...components,
  },
  directives,
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#2AB3BA',
          secondary: '#53BE8C',
          accent: '#A8CC47',
          'accent-darken': '#637b22',
          error: '#CC2020',
          'error-darken': '#881515',
          success: '#53BE8C',
          anchor: '#2AB3BA',
          'on-success': '#fff',
          'mid-gray': '#797979',
          'dark-orange': '#AC7A37',
        },
      },
    },
  },
  aliases: {
    VBtnDialogOk: components.VBtn,
    VBtnDialogCancel: components.VBtn,
    VBtnDialogDelete: components.VBtn,
  },
  defaults: {
    VSelect: { variant: 'underlined' },
    VTextField: { variant: 'underlined' },
    VFileInput: { variant: 'underlined' },
    VCombobox: { variant: 'underlined' },
    VAutocomplete: { variant: 'underlined' },
    VDateInput: { variant: 'underlined' },
    VBtn: { variant: 'outlined', rounded: 'lg', style: 'text-transform: none;', },
    VFab: { rounded: 'xl' },
    VCardActions: {
      VBtn: { variant: 'outlined', rounded: 'lg' },
    },
    VDataTableRow: {
      VBtn: { variant: 'outlined', size: 'x-small' },
    },
    VDialog: {
      VCardActions: {
        VBtn: { variant: 'text' },
      }
    },
    VBtnDialogOk: {
      rounded: 'lg',
      color: 'primary',
      variant: 'flat',
      style: 'text-transform: none;',
    },
    VBtnDialogCancel: {
      rounded: 'lg',
      variant: 'outlined',
      style: 'text-transform: none;',
    },
    VBtnDialogDelete: {
      rounded: 'lg',
      variant: 'flat',
      color: 'error',
      prependIcon: 'mdi-delete-outline',
      style: 'text-transform: none;',
    },
  },
});
